import { Observable } from 'rxjs'

export abstract class MbLogoutAdapter {
  abstract load(): Observable<any>
}
